import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void;
  }
}

export function AnalyticsTracker() {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-BZZK42FL2E', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  // Track outbound link clicks
  useEffect(() => {
    const handleOutboundClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const link = target.closest('a');
      
      if (link && link.href) {
        try {
          const url = new URL(link.href, window.location.href);
          if (url.hostname !== window.location.hostname) {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'click', {
                event_category: 'outbound_link',
                event_label: link.href,
                transport_type: 'beacon'
              });
            }
          }
        } catch (e) {
          // Ignore invalid URLs
        }
      }
    };

    document.addEventListener('click', handleOutboundClick);
    return () => {
      document.removeEventListener('click', handleOutboundClick);
    };
  }, []);

  return null;
}
